import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaWater, FaUsers, FaGlobe, FaShieldAlt } from 'react-icons/fa';
import SEO from '../components/SEO';
import './AboutPage.css';

const AboutPage = () => {
  return (
    <div className="about-page">
      <SEO
        title="About Us - DiveConnect"
        description="Learn about DiveConnect — our mission, our team, and our passion for connecting divers with unforgettable underwater experiences worldwide."
      />

      {/* Hero */}
      <div className="about-hero">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h1 className="about-hero-title">About DiveConnect</h1>
              <p className="about-hero-subtitle">
                We're a community built by divers, for divers — connecting passionate
                underwater explorers with unforgettable experiences around the world.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Mission */}
      <section className="about-mission">
        <Container>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <h2 className="about-section-title">Our Mission</h2>
              <p className="about-text">
                DiveConnect was founded with a simple goal: make it easy for anyone to
                discover, book, and enjoy world-class scuba diving trips without the hassle.
              </p>
              <p className="about-text">
                Whether you're a seasoned diver exploring remote reefs or a beginner taking
                your first plunge, we curate experiences that match your skill level and
                sense of adventure.
              </p>
              <p className="about-text">
                Every trip on our platform is led by certified, experienced dive guides who
                prioritise safety, conservation, and making sure you have the time of your life.
              </p>
            </Col>
            <Col lg={6}>
              <div className="about-image-placeholder">
                <FaWater className="about-placeholder-icon" />
                <span>Exploring the deep since 2020</span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Values */}
      <section className="about-values">
        <Container>
          <div className="text-center mb-5">
            <h2 className="about-section-title">What We Stand For</h2>
          </div>
          <Row className="g-4">
            <Col md={6} lg={3}>
              <div className="value-card">
                <div className="value-icon"><FaShieldAlt /></div>
                <h4>Safety First</h4>
                <p>Every trip follows strict safety protocols. Our guides are fully certified and equipment is always up to standard.</p>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="value-card">
                <div className="value-icon"><FaGlobe /></div>
                <h4>Conservation</h4>
                <p>We care deeply about the oceans we explore. We partner with eco-conscious operators and promote responsible diving.</p>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="value-card">
                <div className="value-icon"><FaUsers /></div>
                <h4>Community</h4>
                <p>Diving is better together. Our platform connects like-minded divers so you never have to explore alone.</p>
              </div>
            </Col>
            <Col md={6} lg={3}>
              <div className="value-card">
                <div className="value-icon"><FaWater /></div>
                <h4>Adventure</h4>
                <p>From beginner reef dives to advanced wreck explorations, we have trips for every level of diver.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2>Ready to Dive In?</h2>
              <p>Browse our upcoming trips and find your next underwater adventure.</p>
              <Link to="/trips" className="btn btn-primary btn-lg me-3">Browse Trips</Link>
              <Link to="/register" className="btn btn-outline-light btn-lg">Join Free</Link>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AboutPage;
